module.exports = __webpack_public_path__ + "/content/shared/img/acura/vdp-thumb-lg-4.jpg";